import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import StockStatus from '../StockStatus';
import WishListButton from '../WishList/WishListButton';
import BuyButtonContainer from '../../Containers/BuyButton.container';
import { translate } from '../../Services/translation';
import Price from '../Price';
import useIsAuthenticated from '../../Hooks/useIsAuthenticated';
import SellerBox from '../SellerBox';
import { SellerBoxSizes } from '../../constants';
import useEcommerceDisabled from '../../Hooks/useEcommerceDisabled';
import EditorString from '../EditorString';
import { InfoBoxPlacements } from '../../constants';

const ProductPageBuyBox = ({
  product,
  className,
  id,
  seller,
  uspText,
  visibleFields,
}) => {
  const [ buyQuantity, setBuyQuantity ] = useState(0);
  const isAuthenticated = useIsAuthenticated();
  const ecommerceDisabled = useEcommerceDisabled();
  const { contactUsPageUrl, contactUsPageDepartmentId } = useSelector(
    (state) => state.site
  );
  const {
    name,
    isInStock,
    stockStatusDescription,
    price,
    boxQuantity,
    id: productId,
    packageSize,
    quantity,
    parentCategory,
    currency,
    stockMessage,
  } = product;

  return (
    <div className={className} id={id}>
      <div className="buy-box__title-and-wish-list">
        {name && (
          <div className="buy-box__title-and-category">
            <h1 className="buy-box__title">{name}</h1>
            {parentCategory && (
              <div className="buy-box__category"> {parentCategory} </div>
            )}
          </div>
        )}
        {isAuthenticated && (
          <WishListButton articleId={productId} quantity={quantity} />
        )}
      </div>
      {visibleFields && !!visibleFields.length && (
        <div className="buy-box__specifications">
          {visibleFields.map((field) => (
            <div className="buy-box__specification-row" key={field.id}>
              {field.name}: <span>{field.value}</span>
            </div>
          ))}
        </div>
      )}
      {isAuthenticated && !ecommerceDisabled && (
        <>
          <StockStatus
            inStock={isInStock}
            description={stockStatusDescription}
            showInfoBox={true}
            stockMessage={stockMessage}
            placement={InfoBoxPlacements.Bottom}
          />
          {price && (
            <Price
              price={price}
              packageSize={boxQuantity}
              currency={currency}
              priceOnRequestLabel='price.on-request-pdp'
              showForQuantity={buyQuantity}
            />
          )}
        </>
      )}
      {!ecommerceDisabled ? (
        <>
          <BuyButtonContainer
            articleNumber={productId}
            buyButtonLabel={translate('product.add-to-cart')}
            enquiryButtonLabel={translate('product.add-to-enquiry')}
            wrapperClassName={'buy-button-container--pdp'}
            packageSize={packageSize}
            onChangeQuantity={newQuantity => setBuyQuantity(newQuantity)}
          />
          <div className="buy-box__quantity-info">
            {translate('product.quantity-info')}
          </div>
        </>
      ) : contactUsPageUrl ? (
        <a
          className="buy-box__contact-us-anchor"
          href={
            contactUsPageDepartmentId
              ? contactUsPageUrl + '#' + contactUsPageDepartmentId
              : contactUsPageUrl
          }
        >
          {translate('product.contact-us')}
        </a>
      ) : null}
      {uspText?.value && <EditorString value={uspText.value} />}
      {seller && <SellerBox size={SellerBoxSizes.small} seller={seller} />}
    </div>
  );
};

export default ProductPageBuyBox;
